__turbopack_context__.v({
  "popover": "Popover-module-scss-module__ZbbLua__popover",
  "slide-down-and-fade": "Popover-module-scss-module__ZbbLua__slide-down-and-fade",
});
